/* eslint-disable @stencil-community/required-jsdoc */
import { Memoize, parseIfString } from '@springbokagency/stencil-base';
import { Component, Host, h, Prop, getAssetPath } from '@stencil/core';
import type { EfbButton } from '../../atoms/button/button';

/**
 * Flora banner component.
 */
@Component({
  tag: 'efb-flora-banner',
  styleUrl: 'flora-banner.scss',
  shadow: true,
})
export class EfbFloraBanner {
  @Prop() titleText: string;

  @Prop() text: string;

  @Prop() usp?: string[] | string;

  @Memoize('usp')
  get parsedUsp(): string[] {
    return parseIfString(this.usp);
  }

  @Prop() highlightTitle?: string;

  @Prop() button: EfbButton | string;

  @Memoize('button')
  get parsedButton(): EfbButton {
    return parseIfString(this.button);
  }

  render() {
    return (
      <Host>
        <section class="flora-banner">
          <div class="content">
            <div class="logo-wrapper">
              <img
                class="logo"
                src={getAssetPath('/dist/assets/images/logos/flora-logo.png')}
                srcset={`${getAssetPath('/dist/assets/images/logos/flora-logo@2x.png')} 2x`}
                alt="Flora"
                loading="lazy"
                width={189}
                height={96}
              />
            </div>

            <div class="text-wrapper">
              {/* Title */}
              {this.titleText && <h2 class="title">{this.titleText}</h2>}

              {/* Text */}
              {this.text && <efb-paragraph text={this.text} />}

              <div class="bottom-wrapper">
                <div class="highlight-block">
                  {/* Title */}
                  {this.highlightTitle && <efb-title tag="h3" text={this.highlightTitle} bold />}

                  {/* Button */}
                  {this.parsedButton && <efb-button {...this.parsedButton} />}
                </div>

                {/* USP */}
                {this.parsedUsp && (
                  <ul class="usp-list">
                    {this.parsedUsp.map((usp) => (
                      <li class="usp-list-item">
                        <efb-icon class="check-icon" name="check" />
                        <efb-paragraph text={usp} />
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </section>
      </Host>
    );
  }
}
